import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AdminApp } from "./AdminApp";
import "./styles.css";

const root = document.getElementById("root");
if (root === null) throw new Error("Admin root is unavailable");
createRoot(root).render(<StrictMode><AdminApp /></StrictMode>);
